// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__15yRh","title":"Info_title__2Bkcl","links":"Info_links__12bBH","link":"Info_link__3tBtA","logo":"Info_logo__3-aFs"};